import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbnormalFlag } from 'src/app/types/sheet-action-aggregate-graph.types';

@Component({
	selector: 'app-abnormal-flag-indicator',
	templateUrl: './abnormal-flag-indicator.component.html',
	styleUrls: ['./abnormal-flag-indicator.component.scss'],
	imports: [],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AbnormalFlagIndicatorComponent {

	@Input() flag: AbnormalFlag | null = null;

	AbnormalFlag = AbnormalFlag;

	constructor() { }
}
